import { COU_httpPost } from '@/utils/http'

// 获取淘特/1688分享链接的真实地址
async function GetGoodsTrueUrl(u, platform) {
  const url = `/util/${platform}TrueUrl` 
  const r = await COU_httpPost({ url, data: { u } })
  let link = '', msg = '', success = false
  try {
    success = r.success
    msg = r.msg
    link = r.result
  } 
  catch (error) {
    console.log(error)
  }
  return { success, msg, link }
}

export default {
  GetGoodsTrueUrl
}